<template>
  <div class="custom-file">
    <input
      ref="input"
      type="file"
      @change="onChange"
      class="custom-file-input"
      :accept="supportedFormats"
      :id="id"
      :aria-describedby="id" />
    <label
      class="custom-file-label"
      :for="id">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: 'file-input',
  props: {
    id: {
      default: '',
      type: String,
      required: true
    },
    label: {
      default: 'Wybierz plik',
      type: String
    },
    onChange: {
      default: () => false,
      required: false,
      type: Function
    },
    supportedFormats: {
      default: () => null,
      required: false,
      type: String
    }
  },
  mounted () {
    this.$refs['input'].addEventListener('change', this.updateLabel);
  },
  methods: {
    updateLabel (e) {
      let fileName = document.getElementById(this.id).files[0].name;
      let nextSibling = e.target.nextElementSibling
      nextSibling.innerText = fileName;
    },
    clear () {
      this.$refs['input'].value = '';
    }
  },
  beforeUnmount () {
    this.$refs['input'].removeEventListener('change', this.updateLabel);
  }
}
</script>

<style scoped>
.custom-file {
  width: 100%;
  display: flex;
}

.custom-file-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.custom-file-label {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 0;
}

.custom-file-label::after {
  content: "Szukaj" !important;
  margin-left: auto;
  margin-right: 0;
}
</style>
